export const CONNECTIONS = 'CONNECTIONS';